var _style, _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.2 79.4",
    style: {
      enableBackground: "new 0 0 79.2 79.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#1A1A1A;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.0899,
    y1: 39.7128,
    x2: 77.0899,
    y2: 39.7128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001838321,
    style: {
      stopColor: "#EF7C47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC63B"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 39.6,
    cy: 39.7,
    r: 37.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.6,79.2c-21.8,0-39.5-17.7-39.5-39.5S17.8,0.2,39.6,0.2s39.5,17.7,39.5,39.5S61.4,79.2,39.6,79.2z  M39.6,4.2C20,4.2,4.1,20.1,4.1,39.7S20,75.2,39.6,75.2s35.5-15.9,35.5-35.5S59.2,4.2,39.6,4.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.4,51.9l-3.6-1.8c2.8-5.7,8.5-9.2,14.9-9.2c6.3,0,12,3.5,14.8,9.1L52,51.8c-2.2-4.3-6.5-6.9-11.2-6.9 C35.9,44.9,31.6,47.6,29.4,51.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 27.4,
    cy: 28.7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.4,
    cy: 28.7,
    r: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.fd047880e0c1b7925100bf7da8fd1070.svg";
export { ForwardRef as ReactComponent };